module.exports = __webpack_public_path__ + "static/media/trophy.26898034.svg";